export default __webpack_public_path__ + "static/tutorialPicture3-01931cecdb7f7c89d40bc0c709c4d4fa.jpg";